//app/dipendente/dipendenti.js

(function () {
    'use strict';
    var controllerId = 'dipendente';
    angular.module('app').controller(controllerId, ['$rootScope', '$scope', '$routeParams', '$filter', 'common', '$location', 'bootstrap.dialog', '$uibModal', 'datacontext', 'sectionMenu', '$translate', dipendenteFn]);

    function dipendenteFn($rootScope, $scope, $routeParams, $filter, common, $location, bDialog, $uibModal, datacontext, sectionMenu, $translate) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this, onRouteChangeOff;
        //vm.title = 'Dipendenti';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection('Dipendenti');                
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;        
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        vm.super = $rootScope.isAuthorized('SUPER');
        vm.personale = $rootScope.isAuthorized('PERSONALE');
        vm.capoSezione = $rootScope.isAuthorized('CAPOSEZIONE');
        vm.addDisabled = !vm.super && !vm.personale;

        vm.item = {};

        //datapicker
        vm.dtInizio_open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.dtInizio_opened = !vm.dtInizio_opened;
            vm.dtFine_opened = vm.dtNascita_opened = false;
        };
        vm.dtFine_open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.dtFine_opened = !vm.dtFine_opened;
            vm.dtInizio_opened = vm.dtNascita_opened = false;
        };
        vm.dtNascita_open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.dtNascita_opened = !vm.dtNascita_opened;
            vm.dtInizio_opened = vm.dtFine_opened = false;
        };
        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        vm.format = 'dd/MM/yyyy';
                
        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['Nominativo', 'Matricola'];
        vm.list.ordine = common.setOrdine(vm.list.ordine);
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
            vm.cerca();
        };

        //Elenchi dettaglio       
        vm.list.profili = [];           //Profili orari del dipendente
        vm.list.profiloOre = [];        //Elenco profili orari generale
        vm.list.aziendePartner = [];
        vm.list.province = [];
        vm.list.comuni = [];
        vm.list.ruoli = [];
        vm.list.aziendePartner = [];
        vm.list.sezioni = [];
        
        //Filtro
        vm.filter = {};
        vm.filter.stato = vm.fStato = 0;
        vm.filter.ricerca = vm.fRicerca = '';
        vm.filter.aziendaPartner = vm.fAziendaPartner = 0;
        vm.filter.ruolo = vm.fRuolo = 0;
        
        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;              
        vm.getRecord = getRecord;        
        vm.get = getRecord;       
        vm.update = updateItem;
        vm.add = addDipendente;
        vm.delete = deleteItem;

        vm.getComuni = getComuni;

        //Gestione costi        
        vm.addCosto = addCosto;
        vm.editCosto = editCosto;
        vm.deleteCosto = deleteCosto;

        //Gestione profilo orario 
        vm.addProfilo = addProfilo;
        vm.editProfilo = editProfilo;
        vm.deleteProfilo = deleteProfilo;

        //Gestione account
        vm.getAccount = getAccount;
        vm.updateAccount = updateAccount;
        vm.updatePassword = updatePassword;
        vm.resetPassword = resetPassword;
        vm.invioCredenziali = invioCredenziali;
        vm.newAccount = newAccount;

        //Gestione team
        vm.getTeam = getTeam;
        vm.addTeam = addTeam;
        vm.deleteTeam = deleteTeam;

        //Gestione commessa
        vm.getCommessa = getCommessa;
        vm.addCommessa = addCommessa;
        vm.deleteCommessa = deleteCommessa;

        //Gestione sezione
        vm.getSezione = getSezione;
        vm.addSezione = addSezione;
        vm.deleteSezione = deleteSezione;

        vm.confirmRoute = confirmRoute;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getProfiloOre(), getListAziendePartner(), getRuoli(), getProvince()];
            common.activateController(promises, controllerId)
                .then(function () {
                    if ($routeParams.DipendenteId != null) {
                        setView('detail');
                        getRecord($routeParams.DipendenteId, 0);
                    }
                });
        }

        //****************************************************
        /*CONFIRM SAVE BEFORE CHANGE ROUTE */
        //****************************************************
        function init() {
            //initialize data here..    
            vm.item.editForm = false;
            vm.item.editFormAccount = false;

            //Make sure they"re warned if they made a change but didn"t save it
            //Call to $on returns a "deregistration" function that can be called to
            //remove the listener (see routeChange() for an example of using it)
            onRouteChangeOff = $scope.$on("$locationChangeStart", routeChange);
        }
        init();

        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            if (view == 'list')
                cerca();
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;
            vm.filter.stato = vm.fStato == null ? 0 : vm.fStato;
            vm.filter.ricerca = vm.fRicerca == null ? '' : vm.fRicerca;
            vm.filter.aziendaPartner = vm.fAziendaPartner == null ? 0 : vm.fAziendaPartner;
            vm.filter.ruolo = vm.fRuolo == null ? 0 : vm.fRuolo;

            vm.loading = false;
            countByFilter();
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.dipendenteConRuolo_countAll(vm.filter.stato, vm.filter.ricerca, vm.filter.aziendaPartner, vm.filter.ruolo).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.dipendenteConRuolo_getAll(vm.pageSize, vm.page, vm.filter.stato, vm.filter.ricerca, vm.filter.aziendaPartner, vm.filter.ruolo, vm.ordine.value).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    vm.records.push.apply(vm.records, data);                   
                }
                vm.loading = false;               
            });            
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getRecord(id, index) {            
            vm.list.profili = [];            

            return datacontext.dipendente_get(id).then(function (data) {                
                vm.index = index;

                if(data.ProvinciaId)
                    getComuni(data.ProvinciaId); 

                if (data.DataNascita) data.DataNascita = new Date(data.DataNascita);
                if (data.DataInizio) data.DataInizio = new Date(data.DataInizio);
                if (data.DataFine) data.DataFine = new Date(data.DataFine);

                vm.record = data;
                getRuoli();

                if (vm.record.Costi.length > 0)
                    vm.record.CostoOra = vm.record.Costi[0].CostoOra;

                if (vm.super || vm.personale)
                    getAccount();
                                
                setView('detail');
            });
        }      

        function addDipendente() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/dipendenteAdd.html?version=30',
                controller: 'dipendenteAdd'
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('Errore durante la creazione del dato'));

                logSuccess($translate.instant('Record creato con successo'));
                vm.records.push(returnItem);
                vm.countRecords++;
            });
        }

        function updateItem() {
            return datacontext.dipendente_update(vm.record).then(function (data) {
                if (!data) {
                    if (vm.recordForm)
                        vm.recordForm.$setPristine();

                    getRecord(vm.record.Id);
                    logSuccess($translate.instant('Dato salvato'));
                }
                else {
                    if (data == 409)
                        logError($translate.instant('Sigla Protocollo esistente, dato non salvato'));
                    else
                        logError($translate.instant('Impossibile salvare il dato'));
                }
            });
        }

        function deleteItem(item) {
            var msg = " " + $translate.instant('il dipendente') + " " + item.Nominativo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.dipendente_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Impossibile eliminare il dipendente')+ " " + item.Nominativo);
                    logSuccess($translate.instant('Dipendente eliminato con successo'));
                    cerca();
                });
            });
        }

        function confirmRoute(event, newUrl) {
            var attempt = true;

            if (vm.recordForm)
                vm.item.editForm = vm.recordForm.$dirty;

            if (vm.accountForm)
                vm.item.editFormAccount = vm.accountForm.$dirty;

            if (vm.item.editForm) {
                bDialog.confirmationDialog($translate.instant('Modifiche non salvate'), $translate.instant('Sono presenti modifiche non salvate'), $translate.instant('Salva modifiche e procedi'), $translate.instant('Annulla modifiche e procedi')).then(function () { //YES
                    if (vm.recordForm.$valid) {
                        vm.update(vm.recordForm.$event);

                        vm.item.editForm = false;
                        onRouteChangeOff(); //Stop listening for location changes

                        if (newUrl == '') {
                            $location.url("/dipendente");
                        }
                        else
                            $location.path($location.url(newUrl).hash()); //Go to page they're interested in                    

                        return attempt;
                    } else {
                        logError($translate.instant('Compilare i campi obbligatori'));
                        return attempt;
                    }
                }, function (btn) { // NO
                    vm.item.editForm = false;
                    onRouteChangeOff(); //Stop listening for location changes

                    if (newUrl == '') {
                        $location.url("/dipendente");
                    }
                    else
                        $location.path($location.url(newUrl).hash()); //Go to page they're interested in                    

                    vm.change = 0;
                    return attempt;
                });
            } else if (vm.item.editFormAccount) {
                bDialog.confirmationDialog($translate.instant('Modifiche non salvate'), $translate.instant('Sono presenti modifiche non salvate'), $translate.instant('Salva modifiche e procedi'), $translate.instant('Annulla modifiche e procedi')).then(function () { //YES
                    if (vm.accountForm.$valid) {
                        vm.updateAccount(vm.accountForm.$event);

                        vm.item.editFormAccount = false;
                        onRouteChangeOff(); //Stop listening for location changes

                        if (newUrl == '') {
                            $location.url("/dipendente");
                        }
                        else
                            $location.path($location.url(newUrl).hash()); //Go to page they're interested in                    

                        return attempt;
                    } else {
                        logError($translate.instant('Compilare i campi obbligatori'));
                        return attempt;
                    }
                }, function (btn) { // NO
                    vm.item.editFormAccount = false;
                    onRouteChangeOff(); //Stop listening for location changes

                    if (newUrl == '') {
                        $location.url("/dipendente");
                    }
                    else
                        $location.path($location.url(newUrl).hash()); //Go to page they're interested in                    

                    vm.change = 0;
                    return attempt;
                });
            }
            else {
                attempt = false;
                vm.item.editForm = false;
                vm.item.editFormAccount = false;
                onRouteChangeOff(); //Stop listening for location changes
                if (newUrl == '') {
                    $location.url("/dipendente");

                    vm.index = 0;
                }
                else
                    $location.path($location.url(newUrl).hash()); //Go to page they're interested in   
            }

            return attempt;
        }

        function routeChange(event, newUrl, oldUrl) {
            vm.change++;
            if (vm.change == 1) {
                if (confirmRoute(event, newUrl, vm.recordForm)) {
                    event.preventDefault();
                    return;
                }
            }
        }

        //Get list
        function getListAziendePartner() {
            return datacontext.aziendaPartner_getAllList().then(function (data) {                
                return vm.list.aziendePartner = data;
            });
        }

        function getProfiloOre() {
            return datacontext.profiloOre_getAllList().then(function (data) {
                return vm.list.profiloOre = data;
            });
        }
        
        function getProvince() {
            if (vm.list.province.length > 0) return;

            datacontext.arrProvincie().then(function (data) {
                vm.list.province = data;
            });
        }

        function getComuni(idprov) {
            if (!idprov || idprov == 0) return vm.list.comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.list.comuni = data;
            });
        }

        //Gestione costi        
        function addCosto() {
            datacontext.costiBase_getDefault().then(function (data) {
                if (data.constructor === Array) {
                    var modalCosto = {};
                    modalCosto.Id = 0;
                    modalCosto.DipendenteId = vm.record.Id;
                    modalCosto.CostoOra = _.find(data, function (o) { return o.Tipo == "Base"; }).Valore;
                    modalCosto.CostoOraStruttura = _.find(data, function (o) { return o.Tipo == "Struttura"; }).Valore;
                    modalCosto.Anno = (new Date()).getFullYear();

                    var modalInstance = $uibModal.open({
                        backdrop: 'static',
                        keyboard: false,
                        templateUrl: '/app/dipendente/modal/costoAddEdit.html?version=30',
                        controller: 'costoAddEdit',
                        resolve: {
                            costo: function () {
                                return modalCosto;
                            }
                        }
                    });

                    modalInstance.result.then(function (returnItem) {
                        if (!returnItem) return logError($translate.instant('Errore durante la modifica del dato'));

                        logSuccess($translate.instant('Costi aggiunti con successo '));
                        vm.record = getRecord(vm.record.Id, vm.index);
                    });
                }
                else
                    logError($translate.instant('Configurare Costi Base'));
            });
        }

        function editCosto(item) {
            var modalCosto = {};
            angular.copy(item, modalCosto);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/costoAddEdit.html?version=30',   // utilizzo la stessa modale sia per aggiungere che per modificare                                                                           
                controller: 'costoAddEdit',
                resolve: {                                          // in resolve si indicano, separati da virgola, gli oggetti che vuoi passare alla modale
                    costo: function () {                            // in questo caso passiamo un solo oggetto che si chiama 'costo' che ha come valore modalIncontro
                        return modalCosto;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {               // eseguito a seguito della chiusura della modale
                if (!returnItem) return logError($translate.instant('Errore durante la modifica del dato'));   // analizza l'oggetto tornato 'returnItem' = 'costoAddEdit.result'
                //  (può essere nullo se l'aggiornamento non va a buon fine)

                logSuccess($translate.instant('Costi modificati con successo'));
                vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione
            });
        }

        function deleteCosto(item) {
            var msg = " " + $translate.instant('i costi per lanno') + " " + item.Anno;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.costoDipendente_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));
                    vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione
                });
            });
        }

        //Gestione Profilo orario
        function addProfilo() {
            var modalProfilo = {};
            modalProfilo.Id = 0;
            modalProfilo.dipendenteId = vm.record.Id;             

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/profiloOrarioAddEdit.html?version=30',
                controller: 'profiloOrarioAddEdit',
                windowClass: 'modal-wide',
                resolve: {
                    profiliOre: function () {
                        return vm.list.profiloOre;
                    },
                    profilo: function () {
                        return modalProfilo;
                    },
                }
            });

            modalInstance.result.then(function (returnItem) {
                logSuccess($translate.instant('Profilo orario aggiunto con successo'));
                vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione          
            });
        }
      
        function editProfilo(item) {
            var modalProfilo = {};
            angular.copy(item, modalProfilo);

            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/profiloOrarioAddEdit.html?version=30',
                controller: 'profiloOrarioAddEdit',
                resolve: {                    
                    profiliOre: function () {
                        return vm.list.profiloOre;
                    },
                    profilo: function () {                           
                        return modalProfilo;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('Errore durante la modifica del dato'));
                
                logSuccess($translate.instant('Profilo orario modificato con successo'));
                vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione
            });
        }

        function deleteProfilo(item) {
            var msg = " " + $translate.instant('il profilo orario') + " " + item.profiloOreTipo + " " + $translate.instant('dal Dipendente') + " " + vm.record.Nominativo;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.profiloDipendenti_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));
                    logSuccess($translate.instant('Profilo eliminato con successo'));
                    vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione
                });
            });
        }


        //Gestione account
        function getAccount() {            
            datacontext.user_getByDipendenteId(vm.record.Id).then(function (data) {                
                vm.account = data;
                if (vm.account.Id > 0) {
                    vm.account.Password = '';
                    vm.confPassword = '';
                    vm.account.ruolo = vm.account.Roles[0].Id;
                    vm.account.DtAttivazione = new Date(vm.account.DtAttivazione);
                }
            });
        }

        function updateAccount() {
            vm.account.Roles[0] = { 'Id': vm.account.ruolo };
            vm.account.DtAttivazione = new Date(vm.account.DtAttivazione);
            return datacontext.user_update(vm.account).then(function (data) {
                if (!data) {
                    if (vm.accountForm)
                        vm.accountForm.$setPristine();
                    logSuccess($translate.instant('Dato salvato'));
                }
                else
                    logError($translate.instant('Impossibile salvare il dato'));
            });
        }

        function updatePassword() {
            if (vm.account.Password != vm.confPassword) {
                logError($translate.instant('Le due password devono coincidere'));
                return;
            }

            vm.account.DtAttivazione = new Date(vm.account.DtAttivazione);
            return datacontext.user_update(vm.account).then(function (data) {
                if (!data) {
                    logSuccess($translate.instant('Dato salvato'));
                }
                else
                    logError($translate.instant('Impossibile salvare il dato'));
            });
        }

        //Manda una email all'utente con un link di accesso al Reset Password
        //dove l'utente può inserire una nuova password per il suo account
        function resetPassword() {
            var msg = " " + $translate.instant('Sara inviata una email all utente') + " " + vm.account.Username + " " + $translate.instant('contenente le istruzioni per eseguire il reset');
            bDialog.confirmationDialog('Reset Password', msg, 'OK').then(function () {
                return datacontext.user_resetPassword(vm.account.Email).then(function (data) {
                    if (data != "204") return logError($translate.instant('Impossibile eseguire operazione'));

                    logSuccess($translate.instant('Operazione effettuata con successo'));
                });
            });
        }

        function invioCredenziali() {
            var msg = " " + $translate.instant('Sara inviata una email all utente') + " " + vm.account.Username + " " + $translate.instant('contenente le credenziali per accesso alla piattaforma');
            bDialog.confirmationDialog($translate.instant('Invio Credenziali'), msg, 'OK').then(function () {
                return datacontext.user_invioCredenziali(vm.account.Email).then(function (data) {
                    if (data != "204") return logError($translate.instant('Impossibile eseguire operazione'));
                    logSuccess($translate.instant('Operazione effettuata con successo'));
                });
            });
        }

        function getRuoli() {
            if ($rootScope.isAuthorized('SUPER') ||
                $rootScope.isAuthorized('PERSONALE') || vm.capoSezione) {
                return datacontext.role_getAll().then(function (data) {
                    var roles = [];
                    data.forEach(function (item) {
                        if (item.Name != "SUPER")
                            roles.push(item);
                    });
                    return vm.list.ruoli = roles;
                });
            }
            else
                return vm.list.ruoli = [];
        }

        function newAccount() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/userDipendenteAdd.html?version=30',
                controller: 'userDipendenteAdd',
                resolve: {
                    ruoli: function () {
                        return vm.list.ruoli;
                    },
                    dipendenteId: function () {
                        return vm.record.Id;
                    },
                    nominativo: function () {
                        return vm.record.Nominativo;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError($translate.instant('Errore durante la creazione del dato'));

                logSuccess($translate.instant('Record creato con successo'));
                getAccount();
            });
        };

        //Gestione Team
        function getTeam() {
            vm.team = [];
            datacontext.dipendentiTeam_getAll(0, vm.record.Id).then(function (data) {
                if (data.constructor === Array) {
                    data.forEach(function (item) {
                        vm.team.push(
                        {
                            Id: item.Id,
                            ruolo: item.ruolo,
                            team: item.team,
                            teamId: item.teamId,
                            numMembri: item.numMembri
                        }
                       );
                    });
                }
            });
        }
        
        function addTeam() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/teamAdd.html?version=30',
                controller: 'teamAdd',
                windowClass: 'modal-wide',
                resolve: {                   
                }
            });

            modalInstance.result.then(function (returnItem) {
                    var ruolo = returnItem.ruolo;
                    return datacontext.dipendentiTeam_add(returnItem.id, vm.record.Id, ruolo).then(function (data) {
                        if (data == "409")
                            return logError($translate.instant('Dipendente gia presente'));
                        else if (data) {
                            //vm.records[vm.index] = data;
                            logSuccess('Dati salvati');
                            //vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione          
                            getTeam();
                        }
                        else
                            return logError($translate.instant('Impossibile salvare i dati'));
                    });
            });

        }
        function deleteTeam(item) {           
            var msg = " " + $translate.instant('il dipendente') + " " + vm.record.Nominativo + " " + $translate.instant('dal Team')+ " " + item.team;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.dipendentiTeam_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));
                    logSuccess($translate.instant('Team eliminato con successo'));
                    //vm.record = getRecord(vm.record.Id, vm.index);      //Aggiorno i dati in visualizzazione          
                    getTeam();
                });
            });
        }

        //Gestione Commessa
        function getCommessa() {
            vm.commesse = [];
            datacontext.dipendentiCommessa_getAll(0, vm.record.Id).then(function (data) {
                if (data.constructor === Array) {
                    data.forEach(function (item) {
                        vm.commesse.push(
                            {
                                Id: item.Id,
                                ruolo: item.ruolo,
                                commessa: item.commessa,
                                commessaId: item.commessaId,
                                numMembri: item.numMembri
                            }
                        );

                    });
                }
            });
        }

        function addCommessa() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/commessaDipendenteAdd.html?version=30',
                controller: 'commessaDipendenteAdd',
                windowClass: 'modal-wide',
                resolve: {
                }
            });

            modalInstance.result.then(function (returnItem) {
                var ruolo = returnItem.ruolo;
                return datacontext.dipendentiCommessa_add(returnItem.id, vm.record.Id, ruolo).then(function (data) {
                    if (data == "409")
                        return logError($translate.instant('Commessa gia presente'));
                    else if (data == "300")
                        return logError($translate.instant('Leader gia presente'));
                    else if (data == "400" || data == "404")
                        return logError($translate.instant('Impossibile salvare i dati'));
                    else {
                        logSuccess($translate.instant('Dati salvati'));
                        getCommessa();
                    }
                });
            });

        }
        function deleteCommessa(item) {
            var msg = " " + $translate.instant('il dipendente') + " " + vm.record.Nominativo + " " + $translate.instant('dalla commessa') + " "+ item.commessa;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.dipendentiCommessa_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));
                    logSuccess($translate.instant('Commessa eliminata con successo'));
                    getCommessa();
                });
            });
        }

        //Gestione Sezione
        function getSezione() {
            vm.list.sezioni = [];
            datacontext.dipendenteSezione_getAll(0, vm.record.Id).then(function (data) {
                vm.list.sezioni = data;
            });
        }

        function addSezione() {
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dipendente/modal/sezioneDipendenteAdd.html?version=30',
                controller: 'sezioneDipendenteAdd',
                windowClass: 'modal-wide',
                resolve: {
                    dipendenteId: function () {
                        return vm.record.Id;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "409")
                    return logError($translate.instant('Centro di costo gia presente'));
                else if (returnItem == "400" || returnItem == "404")
                    return logError($translate.instant('Impossibile salvare i dati'));
                else {
                    logSuccess($translate.instant('Dati salvati'));
                    getSezione();
                }
            });
        }

        function deleteSezione(item) {
            var msg = " " + $translate.instant('il dipendente') + " " + vm.record.Nominativo + " " + $translate.instant('dal centro di costo') + " " + item.sezione;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.dipendenteSezione_delete(item.Id).then(function (data) {
                    if (data != "204") return logError($translate.instant('Errore durante la rimozione del dato'));
                    logSuccess($translate.instant('Centro di costo eliminato con successo'));
                    getSezione();
                });
            });
        }
    }
})();
